import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import React, { useLayoutEffect, useRef } from 'react'
import styled from 'styled-components';
import Accordion from '../Accordion';
import { useTranslation } from 'react-i18next';

const Section = styled.section`
min-height: 100vh;
height: auto;
width: 100vw;
background-color: ${props => props.theme.text};
position: relative;
color: ${(props) => props.theme.body};
overflow: hidden;


display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
`
const Title = styled.h1`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: uppercase;
  color: ${(props) => props.theme.body};
  
  margin: 1rem auto;
  border-bottom: 2px solid ${(props) => props.theme.carouselColor};
  width: fit-content;

  @media (max-width: 48em){
  font-size: ${(props) => props.theme.fontxl};

  }
`;

const Container = styled.div`
width: 75%;
margin: 2rem auto;

display: flex;
justify-content: space-between;
align-content: center;

@media (max-width: 64em){
  width: 80%;
  }
  @media (max-width: 48em){
  width: 90%;
  flex-direction: column;

  &>*:last-child{
    &>*:first-child{

    margin-top: 0;
}

  }
  }
`
const Box = styled.div`
width: 45%;
@media (max-width: 64em){
  width: 90%;
  align-self: center;
  }

`

const Faq = () => {
const { t, i18n } = useTranslation();
const ref = useRef(null);
gsap.registerPlugin(ScrollTrigger);
useLayoutEffect(() => {
  
  let element = ref.current;

  ScrollTrigger.create({
    trigger: element,
    start:'bottom bottom',
    end:'bottom top',
    pin:true,   
    pinSpacing:false, 
    scrub:1,
    // markers:true,
  })

  return () => {
    ScrollTrigger.kill();
  };
}, [])

  return (
    <Section ref={ref} id="faq">
    <Title>Faq</Title>

    <Container>

<Box>
<Accordion ScrollTrigger={ScrollTrigger} title={t('SectionFAQjs.1')} >
{t('SectionFAQjs.2')}
<br/><br/>{t('SectionFAQjs.3')} 
<br/><br/>{t('SectionFAQjs.4')}
  </Accordion>

  <Accordion ScrollTrigger={ScrollTrigger} title={t('SectionFAQjs.5')}>
  {t('SectionFAQjs.6')}

 <br/><br/>{t('SectionFAQjs.7')}
 <br/><br/>{t('SectionFAQjs.8')} 
 </Accordion>

  <Accordion ScrollTrigger={ScrollTrigger} title={t('SectionFAQjs.9')} >
  {t('SectionFAQjs.10')}
<br/>{t('SectionFAQjs.11')}

<br/><br/>{t('SectionFAQjs.12')}

 <br/><br/>{t('SectionFAQjs.13')}
 </Accordion>

 <Accordion ScrollTrigger={ScrollTrigger} title={t('SectionFAQjs.14')} >
 {t('SectionFAQjs.15')}
  <br/><br/>{t('SectionFAQjs.16')}
  </Accordion>
  
    <Accordion ScrollTrigger={ScrollTrigger} title={t('SectionFAQjs.17')} >
    {t('SectionFAQjs.18')}
  <br/><br/>{t('SectionFAQjs.19')}
  </Accordion>

</Box>
<Box>

   <Accordion ScrollTrigger={ScrollTrigger} title={t('SectionFAQjs.20')} >
   {t('SectionFAQjs.21')}
  </Accordion>

<Accordion ScrollTrigger={ScrollTrigger} title={t('SectionFAQjs.22')} >
{t('SectionFAQjs.23')}
<br/><br/>{t('SectionFAQjs.24')}
  </Accordion>

   <Accordion ScrollTrigger={ScrollTrigger} title={t('SectionFAQjs.25')}>
   {t('SectionFAQjs.26')}

<br/><br/>{t('SectionFAQjs.27')}
<br/><br/>{t('SectionFAQjs.28')}

  </Accordion>

   <Accordion ScrollTrigger={ScrollTrigger} title={t('SectionFAQjs.29')}>
   {t('SectionFAQjs.30')}

<br/><br/>{t('SectionFAQjs.31')}
  </Accordion>
  
</Box>
    </Container>
    </Section>
  )
}

export default Faq